(() => {
  const routes = window.themeRoutes || {};
  const moneyFormat = window.themeMoneyFormat || "${{amount}}";
  const WISHLIST_KEY = "atelier-noir-saved";

  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => [...root.querySelectorAll(sel)];

  function formatMoney(cents) {
    const amount = (Number(cents) / 100).toFixed(2);
    if (moneyFormat.includes("amount_no_decimals")) {
      return moneyFormat.replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)));
    }
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace(".", ","));
  }

  function toast(message) {
    const el = qs("[data-toast]");
    if (!el) return;
    el.textContent = message;
    el.classList.add("is-visible");
    window.clearTimeout(toast._t);
    toast._t = window.setTimeout(() => el.classList.remove("is-visible"), 2400);
  }

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY) || "[]");
    } catch {
      return [];
    }
  }

  function setWishlist(handles) {
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(handles));
    } catch (error) {
      toast("Could not save this look on this device");
      return;
    }
    syncWishlistUI();
  }

  function toggleWishlist(handle, product) {
    const list = getWishlist();
    const exists = list.find((item) => item.handle === handle);
    const next = exists ? list.filter((item) => item.handle !== handle) : [...list, product];
    setWishlist(next);
    toast(exists ? "Removed from saved looks" : "Saved to your looks");
    return !exists;
  }

  function isSaved(handle) {
    return getWishlist().some((item) => item.handle === handle);
  }

  function syncWishlistUI() {
    const count = getWishlist().length;
    qsa("[data-save-handle]").forEach((btn) => {
      const saved = isSaved(btn.dataset.saveHandle);
      btn.classList.toggle("is-saved", saved);
      btn.setAttribute("aria-pressed", saved ? "true" : "false");
      btn.setAttribute("aria-label", saved ? "Remove from saved looks" : "Save this look");
      const heart = btn.querySelector("[data-heart]");
      if (heart) {
        heart.setAttribute("fill", saved ? "#5f3030" : "none");
        heart.setAttribute("stroke", saved ? "#5f3030" : "currentColor");
      }
    });
    qsa("[data-saved-count]").forEach((el) => {
      el.textContent = String(count);
      el.hidden = count === 0;
    });
    qsa("[data-open-saved]").forEach((btn) => btn.classList.toggle("has-saved", count > 0));
    renderWishlistDrawer();
  }

  function escapeHtml(value) {
    return String(value ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function safeSameOriginUrl(value) {
    try {
      const parsed = new URL(value, window.location.origin);
      if (parsed.origin !== window.location.origin) return "#";
      return parsed.pathname + parsed.search + parsed.hash;
    } catch {
      return "#";
    }
  }

  function renderWishlistDrawer() {
    const list = qs("[data-wishlist-list]");
    const empty = qs("[data-wishlist-empty]");
    if (!list || !empty) return;
    const items = getWishlist();
    empty.hidden = items.length > 0;
    list.innerHTML = items
      .map((item) => {
        const url = safeSameOriginUrl(item.url);
        const title = escapeHtml(item.title);
        const image = escapeHtml(item.image);
        const price = escapeHtml(item.price);
        return `
        <li class="drawer-item">
          <a href="${url}">
            <img src="${image}" alt="${title}">
          </a>
          <div>
            <a href="${url}" class="font-display" style="font-size:1.125rem">${title}</a>
            <p style="font-size:.875rem;color:rgba(23,19,19,.5);margin-top:.25rem">${price}</p>
            <button type="button" class="drawer-unsave" data-save-handle="${escapeHtml(item.handle)}" data-save-title="${title}" data-save-url="${url}" data-save-image="${image}" data-save-price="${price}">Remove</button>
          </div>
        </li>`;
      })
      .join("");
  }

  async function fetchCart() {
    const res = await fetch("/cart.js");
    return res.json();
  }

  function renderCart(cart) {
    const countEls = qsa("[data-cart-count]");
    countEls.forEach((el) => (el.textContent = cart.item_count || 0));
    const list = qs("[data-cart-list]");
    const empty = qs("[data-cart-empty]");
    const footer = qs("[data-cart-footer]");
    if (!list || !empty) return;
    empty.hidden = cart.items.length > 0;
    if (footer) footer.hidden = cart.items.length === 0;
    list.innerHTML = cart.items
      .map(
        (item) => `
        <li class="drawer-item" data-key="${item.key}">
          <a href="${item.url}">
            <img src="${item.image || ""}" alt="${item.product_title}">
          </a>
          <div>
            <p class="font-display" style="font-size:1.125rem;line-height:1.2">${item.product_title}</p>
            <p style="margin-top:.25rem;font-size:.875rem;color:rgba(23,19,19,.55)">${item.variant_title || ""}</p>
            <div class="qty">
              <button type="button" data-qty-change="${item.key}" data-qty="${item.quantity - 1}">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-qty-change="${item.key}" data-qty="${item.quantity + 1}">+</button>
            </div>
            <p style="margin-top:.5rem;font-size:.875rem">${formatMoney(item.final_line_price)}</p>
            <button type="button" data-remove="${item.key}" style="margin-top:.5rem;font-size:.75rem;text-transform:uppercase;letter-spacing:.16em;color:rgba(23,19,19,.45)">Remove</button>
          </div>
        </li>`
      )
      .join("");
  }

  async function refreshCart() {
    try {
      const cart = await fetchCart();
      renderCart(cart);
    } catch (err) {
      console.error(err);
    }
  }

  async function addToCart(id, quantity = 1) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id, quantity }),
    });
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      throw new Error(data.description || "Could not add to bag");
    }
    await refreshCart();
    openDrawer("cart");
    toast("Added to your occasion edit");
  }

  async function changeQty(key, quantity) {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity }),
    });
    await refreshCart();
  }

  function openDrawer(name) {
    closeAllOverlays();
    qs(`[data-overlay="${name}"]`)?.classList.add("is-open");
    qs(`[data-drawer="${name}"]`)?.classList.add("is-open");
    document.documentElement.classList.add("drawer-open");
  }

  function closeDrawer(name) {
    qs(`[data-overlay="${name}"]`)?.classList.remove("is-open");
    qs(`[data-drawer="${name}"]`)?.classList.remove("is-open");
    document.documentElement.classList.remove("drawer-open");
  }

  function closeAllOverlays() {
    qsa("[data-overlay], [data-drawer], .search-overlay, .mobile-menu, .mega, .modal").forEach((el) => {
      el.classList.remove("is-open");
    });
    qsa(".site-nav__item").forEach((el) => el.classList.remove("is-open"));
    qsa("[data-open-saved], [data-open-cart]").forEach((btn) => btn.setAttribute("aria-expanded", "false"));
    qs("[data-menu-toggle]")?.setAttribute("aria-expanded", "false");
    document.documentElement.classList.remove("drawer-open");
  }

  function prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function initHeader() {
    const header = qs("[data-header]");
    if (!header) return;
    let closeTimer;

    const onScroll = () => header.classList.toggle("is-scrolled", window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    qsa("[data-nav-item]").forEach((item) => {
      item.addEventListener("mouseenter", () => {
        window.clearTimeout(closeTimer);
        qsa("[data-nav-item]").forEach((el) => el.classList.remove("is-open"));
        qsa(".mega").forEach((el) => el.classList.remove("is-open"));
        item.classList.add("is-open");
        qs(`.mega[data-mega="${item.dataset.navItem}"]`)?.classList.add("is-open");
      });
    });

    header.addEventListener("mouseleave", () => {
      closeTimer = window.setTimeout(() => {
        qsa("[data-nav-item], .mega").forEach((el) => el.classList.remove("is-open"));
      }, 120);
    });

    qs("[data-menu-toggle]")?.addEventListener("click", () => {
      const menu = qs(".mobile-menu");
      const open = !menu.classList.contains("is-open");
      closeAllOverlays();
      if (open) {
        menu.classList.add("is-open");
        qs("[data-menu-toggle]").setAttribute("aria-expanded", "true");
      }
    });

    qsa("[data-mobile-expand]").forEach((btn) => {
      btn.addEventListener("click", () => {
        btn.parentElement.classList.toggle("is-open");
      });
    });

    qs("[data-open-search]")?.addEventListener("click", () => {
      closeAllOverlays();
      qs(".search-overlay")?.classList.add("is-open");
      qs("[data-search-input]")?.focus();
    });

    qsa("[data-open-cart]").forEach((btn) => {
      btn.addEventListener("click", () => {
        openDrawer("cart");
        btn.setAttribute("aria-expanded", "true");
      });
    });
    qsa("[data-open-saved]").forEach((btn) => {
      btn.addEventListener("click", () => {
        openDrawer("saved");
        qsa("[data-open-saved]").forEach((el) => el.setAttribute("aria-expanded", "true"));
      });
    });
    qsa("[data-close-search]").forEach((btn) => btn.addEventListener("click", closeAllOverlays));
    qsa("[data-overlay], [data-close-drawer]").forEach((el) => {
      el.addEventListener("click", () => closeAllOverlays());
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") closeAllOverlays();
    });
  }

  function initSearch() {
    const input = qs("[data-search-input]");
    const results = qs("[data-search-results]");
    if (!input || !results) return;
    let timer;
    input.addEventListener("input", () => {
      window.clearTimeout(timer);
      const q = input.value.trim();
      if (!q) {
        results.innerHTML = "";
        return;
      }
      timer = window.setTimeout(async () => {
        const url = `${routes.predictive_search_url || "/search/suggest"}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&section_id=predictive-search`;
        try {
          const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8`);
          const data = await res.json();
          const products = data.resources?.results?.products || [];
          if (!products.length) {
            results.innerHTML = `<li style="color:rgba(23,19,19,.5)">No pieces match that yet. Try an occasion or a colour.</li>`;
            return;
          }
          results.innerHTML = products
            .map(
              (p) => `
              <li>
                <a class="search-result" href="${p.url}">
                  <img src="${p.image || p.featured_image}" alt="">
                  <span>
                    <span class="font-display" style="display:block;font-size:1.25rem">${p.title}</span>
                    <span style="font-size:.875rem;color:rgba(23,19,19,.5)">${p.price}</span>
                  </span>
                </a>
              </li>`
            )
            .join("");
        } catch {
          window.location.href = `${routes.search_url || "/search"}?q=${encodeURIComponent(q)}`;
        }
      }, 180);
    });
  }

  function initCartEvents() {
    document.addEventListener("click", async (event) => {
      const qtyBtn = event.target.closest("[data-qty-change]");
      if (qtyBtn) {
        await changeQty(qtyBtn.dataset.qtyChange, Number(qtyBtn.dataset.qty));
      }
      const removeBtn = event.target.closest("[data-remove]");
      if (removeBtn) {
        await changeQty(removeBtn.dataset.remove, 0);
      }
    });
  }

  function initProduct() {
    const form = qs("[data-product-form]");
    if (!form) return;
    const select = qs("[data-variant-select]");
    const sizeBtns = qsa("[data-size]");
    const error = qs("[data-size-error]");
    const addBtn = qs("[data-add]");
    const mobileAdd = qs("[data-mobile-add]");

    sizeBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        sizeBtns.forEach((el) => el.classList.remove("is-selected"));
        btn.classList.add("is-selected");
        if (select) select.value = btn.dataset.variantId;
        if (error) error.hidden = true;
      });
    });

    async function submitAdd(event) {
      event.preventDefault();
      const id = select?.value;
      if (!id) {
        if (error) error.hidden = false;
        return;
      }
      try {
        await addToCart(Number(id), 1);
        if (addBtn) addBtn.textContent = "Added to your occasion edit";
        if (mobileAdd) mobileAdd.textContent = "Added";
      } catch (err) {
        toast(err.message);
      }
    }

    form.addEventListener("submit", submitAdd);
    mobileAdd?.addEventListener("click", submitAdd);
    qs("[data-open-guide]")?.addEventListener("click", () => qs("[data-size-guide]")?.classList.add("is-open"));
    qs("[data-close-guide]")?.addEventListener("click", () => qs("[data-size-guide]")?.classList.remove("is-open"));
    qs("[data-size-guide]")?.addEventListener("click", (event) => {
      if (event.target === event.currentTarget) event.currentTarget.classList.remove("is-open");
    });

    const gallery = qs("[data-product-gallery]");
    const main = qs("[data-gallery-main]");
    const mediaWrap = qs("[data-gallery-media]");
    const expandBtn = qs("[data-gallery-expand]");
    const hint = qs(".product-gallery__hint");
    const lightbox = qs("[data-gallery-lightbox]");
    const lightboxImg = qs("[data-lightbox-image]");
    const lightboxStage = qs("[data-lightbox-stage]");
    const lightboxZoomBtn = qs("[data-lightbox-zoom]");
    const lightboxZoomLabel = qs("[data-lightbox-zoom-label]");
    let lightboxZoomed = false;

    function currentGalleryImage() {
      return mediaWrap ? qs("img", mediaWrap) : qs("img", main);
    }

    function setGalleryMedia(type, src, zoomSrc) {
      if (!mediaWrap || !gallery) return;
      gallery.dataset.mediaType = type || "image";
      gallery.dataset.zoomSrc = zoomSrc || src || "";
      if (type === "video") {
        mediaWrap.innerHTML = `<video src="${src}" autoplay muted loop playsinline></video>`;
        if (expandBtn) expandBtn.hidden = true;
        if (hint) hint.hidden = true;
      } else {
        mediaWrap.innerHTML = `<img src="${src}" alt="">`;
        if (expandBtn) expandBtn.hidden = false;
        if (hint) hint.hidden = false;
      }
    }

    function bindHoverInspect() {
      if (!main) return;
      main.onmousemove = (event) => {
        if (gallery?.dataset.mediaType === "video") return;
        if (window.matchMedia("(hover: none)").matches) return;
        const img = currentGalleryImage();
        if (!img) return;
        const box = main.getBoundingClientRect();
        const x = ((event.clientX - box.left) / box.width) * 100;
        const y = ((event.clientY - box.top) / box.height) * 100;
        img.style.transform = "scale(1.35)";
        img.style.transformOrigin = `${x}% ${y}%`;
      };
      main.onmouseleave = () => {
        const img = currentGalleryImage();
        if (img) img.style.transform = "scale(1)";
      };
    }

    function setLightboxZoom(active) {
      lightboxZoomed = active;
      if (!lightboxImg || !lightboxStage) return;
      lightboxImg.classList.toggle("is-zoomed", active);
      lightboxStage.classList.toggle("is-zoomed", active);
      if (lightboxZoomLabel) lightboxZoomLabel.textContent = active ? "Zoom out" : "Zoom in";
      if (!active) {
        lightboxImg.style.transform = "";
        lightboxImg.style.transformOrigin = "center center";
      }
    }

    function openLightbox() {
      if (!lightbox || !lightboxImg || gallery?.dataset.mediaType === "video") return;
      const src = gallery.dataset.zoomSrc || currentGalleryImage()?.src;
      if (!src) return;
      lightboxImg.src = src;
      lightbox.hidden = false;
      document.documentElement.classList.add("gallery-lightbox-open");
      setLightboxZoom(false);
      qs("[data-lightbox-close]", lightbox)?.focus();
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.hidden = true;
      document.documentElement.classList.remove("gallery-lightbox-open");
      setLightboxZoom(false);
      if (lightboxImg) lightboxImg.src = "";
    }

    qsa("[data-thumb]").forEach((btn) => {
      btn.addEventListener("click", () => {
        qsa("[data-thumb]").forEach((el) => el.classList.remove("is-active"));
        btn.classList.add("is-active");
        setGalleryMedia(btn.dataset.mediaType, btn.dataset.src, btn.dataset.zoomSrc);
      });
    });

    expandBtn?.addEventListener("click", (event) => {
      event.stopPropagation();
      openLightbox();
    });

    mediaWrap?.addEventListener("click", () => {
      if (gallery?.dataset.mediaType === "video") return;
      openLightbox();
    });

    qsa("[data-lightbox-close]").forEach((btn) => {
      btn.addEventListener("click", closeLightbox);
    });

    lightboxZoomBtn?.addEventListener("click", (event) => {
      event.stopPropagation();
      setLightboxZoom(!lightboxZoomed);
    });

    lightboxStage?.addEventListener("mousemove", (event) => {
      if (!lightboxZoomed || !lightboxImg) return;
      const box = lightboxStage.getBoundingClientRect();
      const x = ((event.clientX - box.left) / box.width) * 100;
      const y = ((event.clientY - box.top) / box.height) * 100;
      lightboxImg.style.transformOrigin = `${x}% ${y}%`;
      lightboxImg.style.transform = "scale(1.85)";
    });

    lightboxStage?.addEventListener("click", (event) => {
      if (event.target === lightboxImg || event.target === lightboxStage) {
        setLightboxZoom(!lightboxZoomed);
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && lightbox && !lightbox.hidden) closeLightbox();
    });

    bindHoverInspect();
  }

  function initSaves() {
    document.addEventListener("click", (event) => {
      const btn = event.target.closest("[data-save-handle]");
      if (!btn) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      toggleWishlist(btn.dataset.saveHandle, {
        handle: btn.dataset.saveHandle,
        title: btn.dataset.saveTitle,
        url: btn.dataset.saveUrl,
        image: btn.dataset.saveImage,
        price: btn.dataset.savePrice,
      });
    });
    syncWishlistUI();
  }

  function initQuiz() {
    const root = qs("[data-quiz]");
    if (!root) return;
    let products = [];
    try {
      const quizJson = root.querySelector("[data-quiz-products]");
      products = JSON.parse((quizJson && quizJson.textContent) || root.dataset.products || "[]");
    } catch (error) {
      products = [];
    }
    const steps = [
      { key: "moment", options: ["bridal", "sangeet", "cocktail", "festive"] },
      { key: "drama", options: ["quiet", "considered", "unforgettable"] },
      { key: "hour", options: ["day", "dusk", "night"] },
    ];
    const answers = {};
    let step = 0;

    const panels = qsa("[data-quiz-panel]", root);
    const stepBtns = qsa("[data-quiz-step]", root);
    const results = qs("[data-quiz-results]", root);
    const grid = qs("[data-quiz-grid]", root);

    function blob(product) {
      return `${product.title || ""} ${product.type || ""} ${(product.tags || []).join(" ")} ${product.handle || ""}`.toLowerCase();
    }

    function showStep(index) {
      step = index;
      panels.forEach((panel, i) => (panel.hidden = i !== index));
      stepBtns.forEach((btn, i) => btn.classList.toggle("is-active", i === index));
    }

    function recommend() {
      const scored = products.map((product) => {
        let score = 0;
        const text = blob(product);
        const tags = (product.tags || []).map((t) => String(t).toLowerCase());
        if (answers.moment) {
          if (tags.includes(answers.moment) || text.includes(answers.moment)) score += 5;
        }
        if (answers.drama === "quiet" && /saree|anarkali|satin|ivory|soft|quiet/.test(text)) score += 3;
        if (answers.drama === "considered" && /set|drape|cocktail|blouse/.test(text)) score += 3;
        if (answers.drama === "unforgettable" && /lehenga|gown|velvet|sparkle|bridal/.test(text)) score += 3;
        if (answers.hour === "day" && /festive|saree|day|marigold/.test(text)) score += 2;
        if (answers.hour === "dusk" && /sangeet|evening|gold|dusk/.test(text)) score += 2;
        if (answers.hour === "night" && /cocktail|gown|velvet|midnight|night/.test(text)) score += 2;
        return { ...product, score };
      });
      scored.sort((a, b) => b.score - a.score);
      const picked = scored.filter((p) => p.score > 0).slice(0, 3);
      if (picked.length >= 3) return picked;
      const rest = scored.filter((p) => !picked.some((x) => x.handle === p.handle));
      return [...picked, ...rest].slice(0, 3);
    }

    function renderResults() {
      const looks = recommend();
      if (!looks.length) {
        grid.innerHTML = `<p style="grid-column:1/-1;color:rgba(23,19,19,.55)">The edit is still small — browse all pieces while we finish the next drop.</p>`;
        results.classList.add("is-visible");
        return;
      }
      grid.innerHTML = looks
        .map(
          (p) => `
          <article class="product-card">
            <a href="${p.url}">
              <div class="product-card__media card-elegant">
                <img src="${p.image}" alt="${p.title}">
                <span class="tag product-card__tag">${p.type || "Edit"}</span>
              </div>
              <div class="product-card__meta">
                <div>
                  <h3>${p.title}</h3>
                </div>
                <p>${p.price}</p>
              </div>
            </a>
          </article>`
        )
        .join("");
      results.classList.add("is-visible");
    }

    root.addEventListener("click", (event) => {
      const option = event.target.closest("[data-quiz-option]");
      if (option) {
        const key = option.dataset.quizKey;
        answers[key] = option.dataset.quizOption;
        qsa(`[data-quiz-key="${key}"]`, root).forEach((el) => el.classList.remove("is-selected"));
        option.classList.add("is-selected");
        if (step < steps.length - 1) {
          window.setTimeout(() => showStep(step + 1), 180);
        } else if (answers.moment && answers.drama && answers.hour) {
          renderResults();
        }
      }
      const stepBtn = event.target.closest("[data-quiz-step]");
      if (stepBtn) showStep(Number(stepBtn.dataset.quizStep));
      if (event.target.closest("[data-quiz-reset]")) {
        Object.keys(answers).forEach((k) => delete answers[k]);
        qsa("[data-quiz-option]", root).forEach((el) => el.classList.remove("is-selected"));
        results.classList.remove("is-visible");
        showStep(0);
      }
    });
    showStep(0);
  }

  function initCollectionFilters() {
    const root = qs("[data-collection]");
    if (!root) return;
    const cards = qsa("[data-product-card]", root);
    const count = qs("[data-count]", root);
    let filter = "all";
    let sort = "featured";

    function apply() {
      const visible = cards
        .map((card) => {
          const tags = (card.dataset.tags || "").toLowerCase();
          const match = filter === "all" || tags.includes(filter);
          return { card, match, price: Number(card.dataset.price || 0) };
        })
        .filter((item) => item.match);

      if (sort === "price-asc") visible.sort((a, b) => a.price - b.price);
      if (sort === "price-desc") visible.sort((a, b) => b.price - a.price);

      cards.forEach((card) => (card.style.display = "none"));
      const grid = qs("[data-product-grid]", root);
      visible.forEach(({ card }) => {
        card.style.display = "";
        grid?.appendChild(card);
      });
      if (grid && grid.hasAttribute("data-reveal-stagger")) {
        grid.classList.remove("is-in");
        void grid.offsetWidth;
        grid.classList.add("is-in");
      }
      if (count) count.textContent = `${visible.length} pieces`;
    }

    qsa("[data-filter]", root).forEach((btn) => {
      btn.addEventListener("click", () => {
        filter = btn.dataset.filter;
        qsa("[data-filter]", root).forEach((el) => el.classList.toggle("is-active", el === btn));
        apply();
      });
    });
    qs("[data-sort]", root)?.addEventListener("change", (event) => {
      sort = event.target.value;
      apply();
    });
  }

  function initLookbook() {
    const track = qs("[data-lookbook-track]");
    const row = qs("[data-lookbook-row]");
    if (!track || !row) return;
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) return;
    function onScroll() {
      const rect = track.getBoundingClientRect();
      const total = track.offsetHeight - window.innerHeight;
      const progress = Math.min(1, Math.max(0, -rect.top / total));
      row.style.transform = `translateX(${progress * -70}%)`;
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  function initStory(gsap, ScrollTrigger) {
    const section = qs("[data-story]");
    if (!section || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const layers = gsap.utils.toArray("[data-story-layer]", section);
    const copies = gsap.utils.toArray("[data-story-copy]", section);
    const ticks = gsap.utils.toArray("[data-story-tick]", section);
    if (!layers.length) return;
    gsap.set(layers[0], { clipPath: "inset(0% 0% 0% 0%)", scale: 1 });
    gsap.set(layers.slice(1), { clipPath: "inset(100% 0% 0% 0%)", scale: 1.08 });
    gsap.set(copies[0], { autoAlpha: 1, y: 0 });
    gsap.set(copies.slice(1), { autoAlpha: 0, y: 36 });
    gsap.set(ticks, { transformOrigin: "50% 100%" });
    const tones = JSON.parse(section.dataset.tones || "[]");
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top top",
        end: "+=320%",
        pin: true,
        scrub: 0.85,
        anticipatePin: 1,
      },
    });
    tones.forEach((tone, index) => {
      if (index === 0) {
        tl.set(section, { backgroundColor: tone }, 0);
        return;
      }
      tl.to(section, { backgroundColor: tone, duration: 1 }, index);
      tl.to(layers[index - 1], { clipPath: "inset(0% 0% 100% 0%)", scale: 1.12, duration: 1 }, index);
      tl.to(layers[index], { clipPath: "inset(0% 0% 0% 0%)", scale: 1, duration: 1 }, index);
      tl.to(copies[index - 1], { autoAlpha: 0, y: -28, duration: 0.45 }, index);
      tl.fromTo(copies[index], { autoAlpha: 0, y: 40 }, { autoAlpha: 1, y: 0, duration: 0.55 }, index + 0.2);
      tl.to(ticks[index - 1], { scaleY: 0.35, duration: 0.4 }, index);
      tl.to(ticks[index], { scaleY: 1, backgroundColor: "#c9a87c", duration: 0.4 }, index);
    });
  }

  function initCraft(gsap, ScrollTrigger) {
    const section = qs("[data-craft]");
    if (!section || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const layers = gsap.utils.toArray("[data-craft-layer]", section);
    const copies = gsap.utils.toArray("[data-craft-copy]", section);
    if (!layers.length) return;
    gsap.set(layers[0], { clipPath: "inset(0% 0% 0% 0%)" });
    gsap.set(layers.slice(1), { clipPath: "inset(100% 0% 0% 0%)" });
    gsap.set(copies[0], { autoAlpha: 1, y: 0 });
    gsap.set(copies.slice(1), { autoAlpha: 0, y: 32 });
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top top",
        end: "+=280%",
        pin: true,
        scrub: 0.8,
        anticipatePin: 1,
      },
    });
    layers.forEach((_, index) => {
      if (index === 0) return;
      tl.to(layers[index - 1], { clipPath: "inset(0% 0% 100% 0%)", duration: 1 }, index);
      tl.to(layers[index], { clipPath: "inset(0% 0% 0% 0%)", duration: 1 }, index);
      tl.to(copies[index - 1], { autoAlpha: 0, y: -24, duration: 0.4 }, index);
      tl.to(copies[index], { autoAlpha: 1, y: 0, duration: 0.5 }, index + 0.15);
    });
  }

  function initProgress() {
    const bar = qs("[data-progress]");
    if (!bar) return;
    window.addEventListener(
      "scroll",
      () => {
        const max = document.documentElement.scrollHeight - window.innerHeight;
        bar.style.width = `${max > 0 ? (window.scrollY / max) * 100 : 0}%`;
      },
      { passive: true }
    );
  }

  function initCursor() {
    if (!window.matchMedia("(pointer: fine)").matches) return;
    const dot = qs("[data-cursor-dot]");
    const ring = qs("[data-cursor-ring]");
    if (!dot || !ring) return;
    document.documentElement.classList.add("atelier-cursor");
    let x = window.innerWidth / 2;
    let y = window.innerHeight / 2;
    let rx = x;
    let ry = y;
    window.addEventListener("mousemove", (event) => {
      x = event.clientX;
      y = event.clientY;
      dot.style.left = `${x}px`;
      dot.style.top = `${y}px`;
    });
    document.addEventListener("mouseover", (event) => {
      ring.classList.toggle("is-hot", Boolean(event.target.closest("a, button, [data-thumb], .quiz-option")));
    });
    function tick() {
      rx += (x - rx) * 0.16;
      ry += (y - ry) * 0.16;
      ring.style.left = `${rx}px`;
      ring.style.top = `${ry}px`;
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function revealNow(el) {
    el.classList.add("is-in");
  }

  function initHero() {
    const hero = qs("[data-hero]");
    if (!hero) return;
    if (prefersReducedMotion()) {
      hero.classList.add("is-in");
      qsa("video", hero).forEach((video) => {
        video.removeAttribute("autoplay");
        video.pause();
      });
      return;
    }
    window.requestAnimationFrame(() => hero.classList.add("is-in"));
  }

  function initReveals() {
    const singles = qsa("[data-reveal]");
    const groups = qsa("[data-reveal-stagger]");
    if (!singles.length && !groups.length) return;
    if (prefersReducedMotion() || !("IntersectionObserver" in window)) {
      [...singles, ...groups].forEach(revealNow);
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          revealNow(entry.target);
          io.unobserve(entry.target);
        });
      },
      /* Trigger a little earlier so motion starts gently before the block is fully in view */
      { rootMargin: "0px 0px 8% 0px", threshold: 0.08 }
    );
    singles.forEach((el) => io.observe(el));
    groups.forEach((el) => io.observe(el));
  }

  function initPageVeil() {
    const veil = qs("[data-page-veil]");
    if (!veil || prefersReducedMotion()) return;
    document.addEventListener("click", (event) => {
      if (event.target.closest("[data-save-handle], [data-open-saved], [data-open-cart], [data-close-drawer]")) return;
      const link = event.target.closest("a[href]");
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (link.target === "_blank" || link.hasAttribute("download")) return;
      const url = new URL(link.href, window.location.href);
      if (url.origin !== window.location.origin) return;
      if (url.pathname === window.location.pathname && url.search === window.location.search) return;
      if (url.hash && url.pathname === window.location.pathname) return;
      if ("startViewTransition" in document) return;
      event.preventDefault();
      veil.classList.add("is-leaving");
      window.setTimeout(() => {
        window.location.href = link.href;
      }, 280);
    });
  }

  function initLazyVideo() {
    const videos = qsa("video[data-lazy-video]");
    if (!videos.length) return;
    const isRenderable = (video) => video.getClientRects().length > 0;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting && isRenderable(video)) {
            if (video.dataset.src && !video.getAttribute("src")) video.src = video.dataset.src;
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { rootMargin: "200px" }
    );
    videos.forEach((video) => io.observe(video));
  }

  function digitsOnly(value) {
    return String(value || "").replace(/\D/g, "");
  }

  function formatNationalMobile(value) {
    const digits = digitsOnly(value).slice(0, 10);
    if (digits.length <= 5) return digits;
    return digits.slice(0, 5) + " " + digits.slice(5);
  }

  function toIndianMobile(value) {
    let digits = digitsOnly(value);
    if (digits.startsWith("0")) digits = digits.slice(1);
    if (digits.startsWith("91") && digits.length === 12) digits = digits.slice(2);
    if (/^[6-9]\d{9}$/.test(digits)) return { national: digits, e164: "91" + digits };
    return null;
  }

  function buildAuthLoginUrl(email, baseUrl) {
    const fallback = routes.storefront_login_url || routes.account_login_url || "/customer_authentication/login";
    const url = new URL(baseUrl || fallback, window.location.origin);
    url.searchParams.set("login_hint", email);
    if (!url.searchParams.get("return_to")) {
      const next = window.location.pathname + window.location.search;
      if (next && next.indexOf("/customer_authentication/") !== 0) {
        url.searchParams.set("return_to", next);
      }
    }
    return url.pathname + url.search + url.hash;
  }

  function initPhoneCapture() {
    qsa("[data-phone-capture]").forEach((block) => {
      const form = qs("form", block);
      const input = qs("[data-phone-input]", block);
      const emailInput = qs("[data-phone-email]", block);
      const tags = qs("[data-phone-tags]", block);
      const note = qs("[data-phone-note]", block);
      const error = qs("[data-phone-error]", block);
      const source = block.getAttribute("data-phone-source") || "login";
      if (!form || !input || !emailInput) return;
      const submitBtn = qs("[data-submit-btn]", form);

      const showError = (visible) => {
        if (!error) return;
        error.hidden = !visible;
        input.setAttribute("aria-invalid", visible ? "true" : "false");
      };

      const setLoading = (loadingState) => {
        if (!submitBtn) return;
        const label = qs("[data-submit-label]", submitBtn);
        const loading = qs("[data-submit-loading]", submitBtn);
        submitBtn.disabled = loadingState;
        if (label) label.hidden = loadingState;
        if (loading) loading.hidden = !loadingState;
      };

        const saveOnly = block.hasAttribute("data-phone-save-only");
        const goToEmailCode = (email) => {
          window.location.assign(buildAuthLoginUrl(email, block.getAttribute("data-auth-login-url")));
        };

        input.addEventListener("input", () => {
          input.value = formatNationalMobile(input.value);
          if (digitsOnly(input.value).length === 0 || toIndianMobile(input.value)) showError(false);
        });

        form.addEventListener("submit", (event) => {
          const mobile = toIndianMobile(input.value);
          const email = (emailInput.value || "").trim();
          if (!mobile) {
            event.preventDefault();
            showError(true);
            input.focus();
            return;
          }
          if (!email) {
            event.preventDefault();
            emailInput.focus();
            return;
          }

          showError(false);
          input.value = mobile.national;
          if (tags) {
            const base = tags.getAttribute("data-phone-tags-base") || "auth-phone";
            tags.value = base + ",wa-" + mobile.e164;
          }
          if (note) {
            const existing = block.getAttribute("data-customer-note") || "";
            const when = new Date().toISOString().slice(0, 10);
            const keep = String(existing)
              .split("|")
              .map((part) => part.trim())
              .filter((part) => part && !/^AUTH_PHONE=/i.test(part) && !/^source=/i.test(part) && !/^captured=/i.test(part));
            note.value = ["AUTH_PHONE=+" + mobile.e164, "source=" + source, "captured=" + when].concat(keep).join(" | ");
          }

          if (saveOnly) {
            setLoading(true);
            return;
          }

          event.preventDefault();
          setLoading(true);
          const formData = new FormData(form);
          const save = fetch(form.action, {
            method: "POST",
            body: formData,
            credentials: "same-origin",
          }).catch(() => {});
          const wait = new Promise((resolve) => window.setTimeout(resolve, 900));
          Promise.all([save, wait]).finally(() => goToEmailCode(email));
        });
    });
  }

  function initCartTrackingPhone() {
    const root = qs("[data-cart-wa]");
    const form = root && root.closest("form");
    const input = qs("[data-cart-wa-input]", root || document);
    const error = qs("[data-cart-wa-error]", root || document);
    if (!root || !form || !input) return;

    const showError = (visible) => {
      if (!error) return;
      error.hidden = !visible;
      input.setAttribute("aria-invalid", visible ? "true" : "false");
    };

    input.addEventListener("input", () => {
      input.value = formatNationalMobile(input.value);
      const digits = digitsOnly(input.value);
      if (!digits.length || toIndianMobile(input.value)) showError(false);
    });

    form.addEventListener("submit", (event) => {
      const digits = digitsOnly(input.value);
      if (!digits.length) {
        showError(false);
        return;
      }
      const mobile = toIndianMobile(input.value);
      if (!mobile) {
        event.preventDefault();
        showError(true);
        input.focus();
        return;
      }
      input.value = mobile.national;
    });
  }

  const ORDER_PHONE_DISMISS_KEY = "atelier-noir-order-phone-dismiss";

  function initPostOrderPhone() {
    const root = qs("[data-order-phone]");
    if (!root) return;
    try {
      if (localStorage.getItem(ORDER_PHONE_DISMISS_KEY) === "1") return;
    } catch {
      /* continue */
    }

    const hasOrders = root.getAttribute("data-has-orders") === "1";
    const fromCheckout = /\/checkouts\/|thank_you|\/orders\//i.test(document.referrer || "");
    if (!hasOrders && !fromCheckout) return;

    root.hidden = false;
    qsa("[data-order-phone-dismiss]", root).forEach((btn) => {
      btn.addEventListener("click", () => {
        root.hidden = true;
        try {
          localStorage.setItem(ORDER_PHONE_DISMISS_KEY, "1");
        } catch {
          /* ignore */
        }
      });
    });
  }

  const VISIT_SYNC_KEY = "atelier-noir-visit-sync";

  function mergeActivityNote(existing, stamp) {
    const keep = String(existing || "")
      .split("|")
      .map((part) => part.trim())
      .filter((part) => part && !/^LAST_VISIT=/i.test(part) && !/^LAST_LOGIN=/i.test(part));
    const day = String(stamp).slice(0, 10);
    keep.push("LAST_LOGIN=" + stamp);
    keep.push("LAST_VISIT=" + day);
    return keep.join(" | ");
  }

  function initCustomerActivity() {
    if (window.self !== window.top) return;
    const root = qs("[data-customer-activity]");
    if (!root) return;
    const form = qs("form", root);
    const noteInput = qs("[data-activity-note]", root);
    if (!form || !noteInput) return;

    const today = root.getAttribute("data-today") || "";
    const recorded = root.getAttribute("data-recorded-day") || "";
    const needsSyncTag = root.getAttribute("data-needs-sync-tag") === "1";
    if (today && recorded === today && !needsSyncTag) return;
    try {
      if (
        !needsSyncTag &&
        today &&
        localStorage.getItem(VISIT_SYNC_KEY) === today &&
        recorded === today
      ) {
        return;
      }
    } catch {
      /* continue */
    }

    const stamp = root.getAttribute("data-now") || today;
    noteInput.value = mergeActivityNote(root.getAttribute("data-customer-note") || "", stamp);
    form.setAttribute("target", "CustomerActivityFrame");

    window.setTimeout(() => {
      try {
        form.submit();
        if (today) localStorage.setItem(VISIT_SYNC_KEY, today);
      } catch {
        /* ignore */
      }
    }, 400);
  }

  function initAccountSheet() {
    function openShopifyAccount() {
      const account = qs("shopify-account");
      if (!account) return;
      closeAllOverlays();
      const trigger = account.querySelector("[slot='signed-out-avatar']") || account;
      window.setTimeout(() => {
        if (typeof trigger.click === "function") trigger.click();
        else account.click();
      }, 80);
    }

    qsa("[data-open-account]").forEach((btn) => {
      btn.addEventListener("click", (event) => {
        event.preventDefault();
        openShopifyAccount();
      });
    });
  }

  function initAccountForms() {
    const root = qs("[data-account-auth]") || document;
    const loginPanel = qs("[data-login-panel]", root);
    const recoverPanel = qs("[data-recover-panel]", root);

    function showRecover() {
      if (!loginPanel || !recoverPanel) return;
      loginPanel.hidden = true;
      recoverPanel.hidden = false;
      const email = qs("#RecoverEmail", recoverPanel);
      if (email) email.focus();
    }

    function showLogin() {
      if (!loginPanel || !recoverPanel) return;
      recoverPanel.hidden = true;
      loginPanel.hidden = false;
      const email = qs("#CustomerEmail", loginPanel);
      if (email) email.focus();
    }

    qsa("[data-show-recover]", root).forEach((el) => {
      el.addEventListener("click", (event) => {
        event.preventDefault();
        showRecover();
        if (history.replaceState) history.replaceState(null, "", "#recover");
      });
    });

    qsa("[data-show-login]", root).forEach((el) => {
      el.addEventListener("click", (event) => {
        event.preventDefault();
        showLogin();
        if (history.replaceState) history.replaceState(null, "", "#login");
      });
    });

    if (window.location.hash === "#recover") showRecover();

    qsa("[data-toggle-password]", document).forEach((btn) => {
      btn.addEventListener("click", () => {
        const wrap = btn.closest(".account-password");
        const input = wrap && qs("[data-password-input]", wrap);
        if (!input) return;
        const show = input.type === "password";
        input.type = show ? "text" : "password";
        const eyeShow = qs("[data-eye-show]", btn);
        const eyeHide = qs("[data-eye-hide]", btn);
        if (eyeShow) eyeShow.hidden = show;
        if (eyeHide) eyeHide.hidden = !show;
        btn.setAttribute("aria-label", show ? "Hide password" : "Show password");
      });
    });

    qsa("[data-account-form]", document).forEach((form) => {
      form.addEventListener("submit", (event) => {
        const password = qs("[data-register-password]", form);
        const confirm = qs("[data-register-confirm]", form);
        const confirmError = qs("[data-confirm-error]", form);
        if (password && confirm) {
          if (password.value !== confirm.value) {
            event.preventDefault();
            if (confirmError) confirmError.hidden = false;
            confirm.focus();
            return;
          }
          if (confirmError) confirmError.hidden = true;
        }

        const btn = qs("[data-submit-btn]", form);
        if (!btn) return;
        const label = qs("[data-submit-label]", btn);
        const loading = qs("[data-submit-loading]", btn);
        btn.disabled = true;
        if (label) label.hidden = true;
        if (loading) loading.hidden = false;
      });
    });

    qsa("[data-edit-address]", document).forEach((btn) => {
      btn.addEventListener("click", () => {
        const id = btn.getAttribute("data-edit-address");
        const form = qs(`[data-address-form="${id}"]`);
        if (!form) return;
        form.hidden = !form.hidden;
      });
    });

    initAddressProvince();
  }

  function initAddressProvince() {
    const selects = qsa("[data-country-select]");
    if (!selects.length) return;

    const bind = () => {
      if (!window.Shopify || !window.Shopify.CountryProvinceSelector) return false;
      selects.forEach((select) => {
        if (select.dataset.bound === "1") return;
        const provinceId = select.getAttribute("data-province-select");
        const hideId = select.getAttribute("data-province-container");
        new window.Shopify.CountryProvinceSelector(select.id, provinceId, {
          hideElement: hideId,
        });
        select.dataset.bound = "1";
      });
      return true;
    };

    if (bind()) return;
    window.addEventListener("load", bind);
    let tries = 0;
    const timer = window.setInterval(() => {
      tries += 1;
      if (bind() || tries > 24) window.clearInterval(timer);
    }, 150);
  }

  document.addEventListener("DOMContentLoaded", () => {
    initHeader();
    initSearch();
    initCartEvents();
    initProduct();
    initSaves();
    initQuiz();
    initCollectionFilters();
    initLookbook();
    initProgress();
    initCursor();
    initLazyVideo();
    initHero();
    initReveals();
    initPageVeil();
    initAccountSheet();
    initAccountForms();
    initPhoneCapture();
    initCartTrackingPhone();
    initPostOrderPhone();
    initCustomerActivity();
    window.__atelierMotionReady = true;
    refreshCart();

    if (window.Lenis) {
      const lenis = new window.Lenis({
        lerp: 0.075,
        smoothWheel: true,
        syncTouch: false,
      });
      function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
      }
      requestAnimationFrame(raf);
      window.lenis = lenis;
    }

    if (window.gsap && window.ScrollTrigger) {
      window.gsap.registerPlugin(window.ScrollTrigger);
      initStory(window.gsap, window.ScrollTrigger);
      initCraft(window.gsap, window.ScrollTrigger);
      if (window.lenis) {
        window.lenis.on("scroll", window.ScrollTrigger.update);
      }
    }
  });
})();
